import React from 'react';
import CloseButton from './CloseButton';
import './MoreProjects.css';

const MoreProjects = ({ onClose }) => {

    return (
        <div className="more-projects">
            <img src='/images/more/project-laescuela-1.webp' alt="laescuela 1"/>
            <img src='/images/more/project-laescuela-2.webp' alt="laescuela 2"/>
            <img src='/images/more/project-madrid-1.webp' alt="madrid destino 1"/>
            <img src='/images/more/project-madrid-2.webp' alt="madrid destino 2"/>
            <img src='/images/more/project-quina-gracia-1.webp' alt="quina gracia 1"/>
            <img src='/images/more/project-quina-gracia-2.webp' alt="quina gracia 2"/>
            <img src='/images/more/project-quina-gracia-3.webp' alt="quina gracia 3"/>
            <img src='/images/more/project-melgarejo-1.webp' alt="melgarejo 1"/>
            <img src='/images/more/project-melgarejo-2.webp' alt="melgarejo 2"/>

            <CloseButton onClose={onClose} />
        </div>
    );
  };

export default MoreProjects;